import {Account, AccountPub} from './account'
import Dashboard from './dashboard'
import {IdnWarnings, Warnings} from '@/modules/base/api/warnings'
export default {
  warnings: Warnings,
  idnWarnings: IdnWarnings,
  account: Account,
  accountPub: AccountPub,
  dashboard: Dashboard
}
